interface ReviewData {
  id: number;
  image: string;
  name: string;
  content: string;
  type: string;
  redirect?: string;
}

function openDatasetHref(event) {
  window.location.href = event.target.closest('.cave-review').dataset.redirect;
}

const isMobile = window.matchMedia('(max-width: 768px)').matches;

function replaceContent(data: ReviewData, element: HTMLElement, isMiddle: boolean = false) {
  // Get HTML elements
  const imageElement = element.querySelector('.cave-review__image') as HTMLImageElement;
  const titleElement = element.querySelector('.cave-review__name') as HTMLHeadingElement;
  const contentElement = element.querySelector('.cave-review__text') as HTMLDivElement;

  // Replace content with provided data
  imageElement.src = data.image;
  titleElement.innerText = data.name;
  contentElement.innerHTML = data.content;

  // Set the type
  element.dataset.type = data.type;

  // Set link if present
  element.dataset.redirect = '';
  if (isMiddle) {
    element.style.cursor = 'unset';
  }
  element.removeEventListener('click', openDatasetHref);
  if (data.redirect && isMiddle) {
    element.dataset.redirect = data.redirect;
    element.addEventListener('click', openDatasetHref);
    element.style.cursor = 'pointer';
  }

  // Set new JSON data
  element.dataset.review = JSON.stringify(data);
}

function addAnimation(element: HTMLElement, callback: Function = () => {}) {
  // Add animating class
  element.classList.add('animating');

  // And remove it after animation finishes
  setTimeout(() => {
    element.classList.remove('animating');
    callback();
  }, 500);
}

function setActive(data: ReviewData, clickedElement: HTMLElement, middleElement: HTMLElement) {
  // Get the middle element data as backup
  const middleElementData = JSON.parse(middleElement.dataset.review);

  // Add animations
  addAnimation(clickedElement);
  addAnimation(middleElement, () => {
    // Set the new data for the middle element
    replaceContent(data, middleElement, true);

    // Set the middle element's data on the clicked element
    replaceContent(middleElementData, clickedElement);

    // If mobile set new height
    if (isMobile) {
      middleElement.parentElement.style.marginBottom = `${
        middleElement.getBoundingClientRect().height
      }px`;
    }
  });
}

function handleClick(middleReview: HTMLElement, event: MouseEvent) {
  const eventTarget = event.target as HTMLElement;
  const wrapper = eventTarget.closest('.cave-reviews') as HTMLElement;
  const review = eventTarget.closest('.cave-review') as HTMLElement;
  const reviewData = JSON.parse(review.dataset.review);

  setActive(reviewData, review, middleReview);

  if (isMobile) {
    wrapper.style.marginBottom = `${middleReview.getBoundingClientRect().height}px`;
  }
}

function isScrolledIntoView(el) {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  // Only completely visible elements return true:
  const isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
  // Partially visible elements return true:
  // isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

function addReviewSwitcher(wrapper: HTMLElement) {
  // Get all reviews in wrapper
  const reviews = wrapper.querySelectorAll('.cave-review') as NodeListOf<HTMLElement>;

  // Select middle review and add a container class
  const middleReview = reviews[Math.floor(reviews.length / 2)];
  middleReview.classList.add('cave-review--container');

  // Add margin bottom if mobile
  if (isMobile) {
    let stop = false;
    wrapper.style.marginBottom = `${middleReview.getBoundingClientRect().height}px`;

    // Check for wrapper by scrolling
    window.addEventListener(
      'scroll',
      () => {
        // Don't try and check after the element
        // has been found
        if (stop) {
          return;
        }

        // If wrapper is in view
        const inView = isScrolledIntoView(wrapper);

        // Resize element if scrolled into view
        if (inView) {
          wrapper.style.marginBottom = `${middleReview.getBoundingClientRect().height}px`;
          stop = true;
        }
      },
      { passive: true },
    );
  }

  // Add event listeners
  reviews.forEach((review) => {
    if (review !== middleReview) {
      review.addEventListener('click', handleClick.bind(null, middleReview));
    } else if (review.dataset.redirect) {
      review.addEventListener('click', openDatasetHref);
      review.style.cursor = 'pointer';
    }
  });
}

function initReviews() {
  const reviewWrappers = document.querySelectorAll('.cave-reviews');
  reviewWrappers?.forEach((wrapper: HTMLElement) => {
    addReviewSwitcher(wrapper);
  });
}

export default initReviews;
